import { OnInit, Component } from '@angular/core';
import { DatePipe } from '@angular/common';

import { HttpErrorResponse } from '@angular/common/http';
import { NzMessageService, NzNotificationService } from 'ng-zorro-antd';

import { GlobalComponent, Tempo, Result, Aziende, Dipendente, Ordine } from '../../environments/global';


@Component({
    selector: 'app-tempi',
    templateUrl: 'tempi.component.html',
    styleUrls: ['tempi.component.scss'],
    providers: [DatePipe]
})
export class TempiComponent implements OnInit {
    // TABLE VARS
    dataSet = [];
    public displayData = [...this.dataSet];
    editCache = {};
    sortName = null;
    sortValue = null;
    // COMPONENT VARS
    newTempo: Tempo = { id: new Date(), date: new Date(), userId: '', orderId: '', h: 0 } as Tempo;
    public newCodeError: string = 'validating';
    isLoading: boolean = true;
    isSpinning: boolean = false;
    companyData: Array<string> = Aziende;
    selectedCompany: string;
    selectedMonth: Date;
    orderData = [];

    usersData = [];
    ordersData = [];
    selectedUsers = [];
    selectedOrders = [];
    // ##########
    insertActive = false;
    insertDay: Date;
    insertCompany: string;
    insertUser: Dipendente;
    insertOrder: Ordine;
    insertHr: number;

    constructor(
        public g: GlobalComponent,
        private notification: NzNotificationService,
        public datepipe: DatePipe,
        private message: NzMessageService) {
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
        this.loadOrders();
        this.loadInserts();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 3;
        this.g.homeTitle = 'Tabella Tempi';
    }
    loadInserts() {
        let query: string = 'SELECT * from chk_users';
        this.g.mysql(query)
            .subscribe((res: Result) => {
                this.usersData = res.data;
            }, (error: HttpErrorResponse) => {
                this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: 0 });
            });

        query = 'SELECT * from chk_orders WHERE `status`= 1';
        this.g.mysql(query)
            .subscribe((res: Result) => {
                this.ordersData = res.data;
            }, (error: HttpErrorResponse) => {
                this.isSpinning = false;
                this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: 0 });
            });
    }
    selectOrders() {
        if (this.insertCompany) {
            this.selectedOrders = this.ordersData.filter(
                o => o.company === this.insertCompany);
            this.insertOrder = null;
        }
    }
    selectUsers() {
        this.selectedUsers = this.usersData.filter(
            u => u.company === this.selectedCompany);
        this.insertUser = null;
    }
    saveLine() {
        let query: string = 'INSERT INTO chk_times (id, date, userId, orderId, h) VALUES';
        const key: string = this.datepipe.transform(new Date(), 'yyyyMMddHHmmss');

        query += '(' + key + ',' +
            '"' + this.datepipe.transform(this.insertDay, 'yyyy-MM-dd') + '",' +
            this.insertUser.id + ',' +
            this.insertOrder.id + ',' +
            this.insertHr + ')';
        this.g.mysql(query)
            .subscribe((res: Result) => {
                this.notification.success('Modifica completata', 'Operazione completata con successo.', { nzDuration: this.g.fastTime });
                this.updateEditCache();
                this.insertUser = null;
                this.insertOrder = null;
                this.insertDay = null;
                this.insertHr = null;
                this.insertCompany = null;
                this.insertActive = false;
            }, (error: HttpErrorResponse) => {
                this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: 0 });
            });
    }

    loadOrders() {
        this.isSpinning = true;
        const query: string = 'SELECT * from chk_orders';
        return this.g.mysql(query)
            .subscribe((res: Result) => {
                this.isLoading = false;
                this.orderData = res.data;
                this.isSpinning = false;
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: this.g.normalTime });
            });
    }
    loadTimes() {
        const startDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth(), 1);
        const endDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, 0);
        // const query: string = 'SELECT * from chk_times INNER JOIN chk_users ON chk_users.id = chk_times.userId' +
        //                     ' WHERE `company` = "' + this.selectedCompany + '"' +
        //                     ' AND `date`>= "' + this.datepipe.transform(startDate, 'yyyy-MM-dd') + '"' +
        //                     ' AND `date`<= "' + this.datepipe.transform(endDate, 'yyyy-MM-dd') + '" ORDER BY `date` DESC';
        const query: string = 'SELECT * from chk_users INNER JOIN chk_times ON chk_users.id = chk_times.userId' +
            ' WHERE `company` = "' + this.selectedCompany + '"' +
            ' AND `date`>= "' + this.datepipe.transform(startDate, 'yyyy-MM-dd') + '"' +
            ' AND `date`<= "' + this.datepipe.transform(endDate, 'yyyy-MM-dd') + '" ORDER BY `date` DESC';
        return this.g.mysql(query)
            .subscribe((res: Result) => {
                this.isLoading = false;
                this.dataSet = res.data;
                //  console.log(res.data[0]); // ##########################################
                this.updateEditCache();
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: this.g.normalTime });
            });
    }
    sort(sort: { key: string, value: string }): void {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        if (this.sortName) {
            this.displayData = [... this.dataSet.sort((a, b) => (this.sortValue === 'ascend') ?
                (a[this.sortName] > b[this.sortName] ? 1 : -1) : (b[this.sortName] > a[this.sortName] ? 1 : -1))];
        } else {
            this.displayData = [...this.dataSet];
        }
    }

    startEdit(id: string): void {
        this.editCache[id].edit = true;
    }

    cancelEdit(id: string): void {
        this.editCache[id].edit = false;
    }
    public getOrder(orderId: string): string {
        const res = this.orderData.find(o => o.id === orderId);
        if (res) { return res.code + ' - ' + res.title; } else { return '(non trovato)'; }

    }

    saveEdit(id: string): void {
        const data: Tempo = this.editCache[id].data;
        const index = this.dataSet.findIndex(item => item.id === id);

        this.dataSet[index] = this.editCache[id].data;
        this.editCache[id].edit = false;
        const query: string = 'UPDATE chk_times SET `h`="' + data.h +
            '", `date`="' + this.datepipe.transform(data.date, 'yyyy-MM-dd') +
            '" where `id`="' + data.id + '"';
        this.isLoading = true;
        this.g.mysql(query)
            .subscribe((res: Result) => {
                this.isLoading = false;
                if (res.error === false) {
                    this.notification.success('Modifica completata', 'Operazione completata con successo.', { nzDuration: this.g.fastTime });
                    this.updateEditCache();
                } else {
                    this.notification.error('Si è verificato un problema, si prega di riprovare tra qualche minuto.', res.message, { nzDuration: 0 });
                    console.log(res);
                }
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.notification.error('Si è vericato un errore non previsto.', error.statusText, { nzDuration: 0 });
            });
    }

    deleteRow(id: string): void {
        const index = this.dataSet.findIndex(item => item.id === id);
        const query: string = 'DELETE FROM chk_times WHERE `id`= ' + id;

        this.isLoading = true;
        this.g.mysql(query)
            .subscribe((res: Result) => {
                this.isLoading = false;
                if (res.error === false) {
                    this.dataSet.splice(index, 1);
                    this.message.success('Cancellazione completata con successo!');
                    this.updateEditCache();
                } else {
                    this.notification.error('Si è verificato un problema, si prega di riprovare tra qualche minuto.', res.message, { nzDuration: this.g.normalTime });
                    console.log(res);
                }
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.notification.error('Si è vericato un errore non previsto.', error.statusText, { nzDuration: 0 });
            });
    }

    updateEditCache(): void {
        if (this.dataSet != null) {
            this.dataSet.forEach(item => {
                if (!this.editCache[item.id]) {
                    this.editCache[item.id] = {
                        edit: false,
                        data: item
                    };
                }
            });
        }
        this.displayData = [...this.dataSet];
    }
}
